export const state = () => ({
    hasTimedOut: false,
})

export const getters = {
    account(state) {
        return state.account
    }
}

export const mutations = {
    SET_TIMED_OUT(state, hasTimedOut) {
        state.hasTimedOut = hasTimedOut
    },
}
